import React from "react";
import { AbsoluteStyle, BorderBottom, BorderColorState, BorderLeft, BorderRight, BorderTop, ColorState, DragBothTitleCard, DragOnlyCard, DragOnlyContent } from "../../Constant";
import { Book, Briefcase, Droplet, Heart, MapPin } from "react-feather";

export const CarouselsData = [
  {
    id: 1,
    img: require("../../assets/images/slider/1.jpg"),
  },
  {
    id: 2,
    img: require("../../assets/images/slider/2.jpg"),
  },
  {
    id: 3,
    img: require("../../assets/images/slider/3.jpg"),
  },
  {
    id: 4,
    img: require("../../assets/images/slider/4.jpg"),
  },
  {
    id: 5,
    img: require("../../assets/images/slider/5.jpg"),
  },
  {
    id: 6,
    img: require("../../assets/images/slider/7.jpg"),
  },
  {
    id: 7,
    img: require("../../assets/images/slider/8.jpg"),
  },
  {
    id: 8,
    img: require("../../assets/images/slider/9.jpg"),
  },
  {
    id: 9,
    img: require("../../assets/images/slider/10.jpg"),
  },
  {
    id: 10,
    img: require("../../assets/images/slider/11.jpg"),
  },
  {
    id: 11,
    img: require("../../assets/images/slider/6.jpg"),
  },
];

export const BasicSweetalrtData = [
  {
    id: 1,
    color: "primary",
    class: "sweet-1",
    name: "basic",
    title: "Basic",
  },
  {
    id: 2,
    color: "primary",
    class: "sweet-2",
    name: "basictitlealert",
    title: "WithTitleAlert",
  },
  {
    id: 3,
    color: "success",
    class: "sweet-3",
    name: "basicsuccessalert",
    title: "SuccessAlert",
  },
  {
    id: 4,
    color: "info",
    class: "sweet-4",
    name: "basicinfoalert",
    title: "InfoAlert",
  },
  {
    id: 5,
    color: "warning",
    class: "sweet-5",
    name: "basicwarningalert",
    title: "WarningAlert",
  },
];
export const AlertSweetalertData = [
  {
    id: 1,
    color: "success",
    class: "sweet-8",
    name: "alertSuccess",
    title: "Success",
  },
  {
    id: 2,
    color: "danger",
    class: "sweet-7",
    name: "alertDanger",
    title: "Danger",
  },
  {
    id: 3,
    color: "info",
    class: "sweet-9",
    name: "alertInfo",
    title: "Information",
  },
  {
    id: 4,
    color: "warning",
    class: "sweet-6",
    name: "alertWarning",
    title: "Warning",
  },
];

export const AdvancedData = [
  {
    id: 1,
    color: "danger",
    class: "sweet-11",
    name: "advanceDanger",
    title: "Danger",
  },
  {
    id: 2,
    color: "info",
    class: "sweet-13",
    name: "advanceInfo",
    title: "Information",
  },
  {
    id: 3,
    color: "warning",
    class: "sweet-10",
    name: "advanceWarning",
    title: "Warning",
  },
];

export const RibbonData = [
  {
    id: 1,
    class: "ribbon ribbon-primary",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 2,
    class: "ribbon ribbon-secondary",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 3,
    class: "ribbon ribbon-success",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 4,
    class: "ribbon ribbon-info",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 5,
    class: "ribbon ribbon-warning",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 6,
    class: "ribbon ribbon-danger",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 7,
    class: "ribbon ribbon-primary ribbon-right",
    title: "Ribbon",
    wrapperClass: "ribbon-wrapper",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 8,
    class: "ribbon ribbon-secondary ribbon-right",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 9,
    class: "ribbon ribbon-success ribbon-right",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 10,
    class: "ribbon ribbon-info ribbon-right",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 11,
    class: "ribbon ribbon-warning ribbon-right",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 12,
    class: "ribbon ribbon-danger ribbon-right",
    wrapperClass: "ribbon-wrapper",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 13,
    class: "ribbon ribbon-primary ribbon-vertical-left",
    wrapperClass: "ribbon-vertical-left-wrapper",
    title: <i className="icofont icofont-love"></i>,
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 14,
    class: "ribbon ribbon-success ribbon-vertical-left",
    wrapperClass: "ribbon-vertical-left-wrapper",
    title: <i className="icon-gift"></i>,
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 15,
    class: "ribbon ribbon-secondary ribbon-vertical-left",
    wrapperClass: "ribbon-vertical-left-wrapper",
    title: <i className="icon-signal"></i>,
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 16,
    class: "ribbon ribbon-primary ribbon-vertical-right",
    wrapperClass: "ribbon-vertical-right-wrapper",
    title: <i className="fa fa-chain-broken"></i>,
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 17,
    wrapperClass: "ribbon-vertical-right-wrapper",
    class: "ribbon ribbon-secondary ribbon-vertical-right",
    title: <i className="fa fa-ticket"></i>,
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 18,
    wrapperClass: "ribbon-vertical-right-wrapper",
    class: "ribbon ribbon-success ribbon-vertical-right",
    title: <i className="fa fa-taxi"></i>,
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 19,
    wrapperClass: "ribbon-wrapper",
    class: "ribbon ribbon-bookmark ribbon-primary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 20,
    wrapperClass: "ribbon-wrapper",
    class: "ribbon ribbon-bookmark ribbon-secondary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 21,
    wrapperClass: "ribbon-wrapper",
    class: "ribbon ribbon-bookmark ribbon-success",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 22,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-bookmark ribbon-right ribbon-primary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 23,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-bookmark ribbon-right ribbon-secondary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 24,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-bookmark ribbon-right ribbon-success",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 25,
    wrapperClass: "ribbon-wrapper",
    class: "ribbon ribbon-clip ribbon-primary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 26,
    wrapperClass: "ribbon-wrapper",
    class: "ribbon ribbon ribbon-clip ribbon-secondary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 27,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-clip ribbon-success",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 28,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-clip-right ribbon-right ribbon-primary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 29,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-clip-right ribbon-right ribbon-secondary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 30,
    wrapperClass: "ribbon-wrapper-right",
    class: "ribbon ribbon-clip-right ribbon-right ribbon-success",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 31,
    wrapperClass: "ribbon-wrapper-bottom",
    class: "ribbon ribbon-clip-bottom ribbon-primary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 32,
    wrapperClass: "ribbon-wrapper-bottom",
    class: "ribbon ribbon-clip-bottom ribbon-secondary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 33,
    wrapperClass: "ribbon-wrapper-bottom",
    class: "ribbon ribbon-clip-bottom ribbon-success",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 34,
    wrapperClass: "ribbon-wrapper-bottom",
    class: "ribbon ribbon-clip-bottom-right ribbon-primary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 35,
    wrapperClass: "ribbon-wrapper-bottom",
    class: "ribbon ribbon-clip-bottom-right ribbon-secondary",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
  {
    id: 36,
    wrapperClass: "ribbon-wrapper-bottom",
    class: "ribbon ribbon-clip-bottom-right ribbon-success",
    title: "Ribbon",
    pera: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text.",
  },
];
export const BasicCardData = [
  {
    id: 1,
    title: "Basic Card",
    bodyClass: "pt-0",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
  },
  {
    id: 2,
    title: "Flat Card",
    bodyClass: "pt-0",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
  },
  {
    id: 3,
    title: "Without Shadow Card",
    bodyClass: "pt-0",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
  },
  {
    id: 4,
    icon: <i className="icofont icofont-truck me-2"></i>,
    title: "Icon In Heading",
    bodyClass: "pt-0",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
  },
  {
    id: 5,
    title: "Card Sub Title",
    bodyClass: "pt-0",
    span: "Using the card component, you can extend the default collapse behavior to create an accordion.",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
  },
  {
    id: 6,
    title: "Card With Footer",
    bodyClass: "pt-0",
    pare: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. LoremIpsum has been the the industrys standard dummy text ever.",
    footer: "Card Footer",
  },
  {
    id: 7,
    title: "Primary Color Card",
    colorClass: "bg-primary",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    footer: "Card Footer",
    settingIcon: true,
  },
  {
    id: 8,
    title: "Secondary Color Card",
    colorClass: "bg-secondary",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    footer: "Card Footer",
    settingIcon: true,
  },
  {
    id: 9,
    title: "Success Color Card",
    colorClass: "bg-success",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    footer: "Card Footer",
    settingIcon: true,
  },
  {
    id: 10,
    title: "Primary Color Header",
    colorClass: "bg-danger",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    footer: "Card Footer",
    settingIcon: true,
  },
  {
    id: 11,
    title: "Primary Color Body",
    bodyClass: "bg-primary",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    footer: "Card Footer",
    settingIcon: true,
    settingPrimary: true,
  },
  {
    id: 12,
    title: "Primary Color Footer",
    footerClass: "bg-primary",
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    footer: "Card Footer",
    settingIcon: true,
    settingPrimary: true,
  },
];

export const CreativeCardData = [
  {
    id: "1",
    title: BorderLeft,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-primary",
  },
  {
    id: "2",
    title: BorderRight,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-r-secondary",
  },
  {
    id: "3",
    title: BorderTop,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-t-success",
  },
  {
    id: "4",
    title: BorderBottom,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-b-info",
  },
  {
    id: "5",
    title: BorderColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-warning",
  },
  {
    id: "6",
    title: BorderColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-danger",
  },
  {
    id: "7",
    title: BorderColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-light",
  },
  {
    id: "8",
    title: BorderColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-primary",
  },
  {
    id: "9",
    title: BorderColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-secondary border-2",
  },
  {
    id: "10",
    title: BorderColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "b-l-primary border-3",
  },
  {
    id: "11",
    cardClass: "card-absolute",
    title: AbsoluteStyle,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "bg-primary",
  },
  {
    id: "12",
    cardClass: "card-absolute",
    title: ColorState,
    pare: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    headerClass: "bg-secondary",
  },
];

export const TabCardData = [
  {
    pare1: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s, when an unknown printer took a galley of type and scrambled.",
    pare2: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industrys standard dummy text ever since the1500s.",
    pare3: "Lorem Ipsum is simply dummy text of the printing andtypesetting industry. Lorem Ipsum has been the industrys standard dummy textever since the 1500s, when an unknown printer took a galley of type andscrambled. Lorem Ipsum is simply dummy text of the printing and typesettingindustry.",
    navClass: "pull-right  nav-pills nav-primary",
    state: "activeTab",
  },
];

export const dragData = [
  {
    title: DragBothTitleCard,
    bordType: "initialBoard",
    board: {
      columns: [
        {
          id: 1,
          title: "Backlog",
          cards: [
            {
              id: 1,
              title: "Add card",
              description: "Add capability to add a card in a column",
            },
          ],
        },
        {
          id: 2,
          title: "Doing",
          cards: [
            {
              id: 2,
              title: "Drag-n-drop support",
              description: "Move a card between the columns",
            },
          ],
        },
      ],
    },
  },
  {
    title: DragOnlyCard,
    bordType: "disableCardDrag",
    board: {
      columns: [
        {
          id: 1,
          title: "Backlog",
          cards: [
            {
              id: 1,
              title: "Add card",
              description: "Add capability to add a card in a column",
            },
          ],
        },
        {
          id: 2,
          title: "Doing",
          cards: [
            {
              id: 2,
              title: "Drag-n-drop support",
              description: "Move a card between the columns",
            },
          ],
        },
      ],
    },
  },
  {
    title: DragOnlyContent,
    bordType: "DragOnlyContent",
    board: {
      columns: [
        {
          id: 1,
          title: "Backlog",
          cards: [
            {
              id: 1,
              title: "Add card",
              description: "Add capability to add a card in a column",
            },
          ],
        },
        {
          id: 2,
          title: "Doing",
          cards: [
            {
              id: 2,
              title: "Drag-n-drop support",
              description: "Move a card between the columns",
            },
          ],
        },
      ],
    },
  },
];

export const FriendsData = [
  {
    id: 1,
    img: require("../../assets/images/user/3.jpg"),
    title: "Jason Borne",
  },
  {
    id: 2,
    img: require("../../assets/images/user/5.jpg"),
    title: "Anna Mull",
  },
  {
    id: 3,
    img: require("../../assets/images/user/2.png"),
    title: "Dion Cast",
  },
  {
    id: 4,
    img: require("../../assets/images/user/3.jpg"),
    title: "Karlene Lex",
  },
  {
    id: 5,
    img: require("../../assets/images/user/6.jpg"),
    title: "Vella Chism",
  },
  {
    id: 6,
    img: require("../../assets/images/user/10.jpg"),
    title: "Wai Schalk",
  },
  {
    id: 7,
    img: require("../../assets/images/user/14.png"),
    title: "Karlene Lex",
  },
  {
    id: 8,
    img: require("../../assets/images/user/1.jpg"),
    title: "Karlene Lex",
  },
  {
    id: 9,
    img: require("../../assets/images/user/4.jpg"),
  },
  {
    id: 10,
    img: require("../../assets/images/user/11.png"),
  },
  {
    id: 11,
    img: require("../../assets/images/user/8.jpg"),
  },
];

export const LatestPhotosData = [
  {
    id: 1,
    img: require("../../assets/images/social-app/post-1.png"),
  },
  {
    id: 2,
    img: require("../../assets/images/social-app/post-2.png"),
  },
  {
    id: 3,
    img: require("../../assets/images/social-app/post-3.png"),
  },
  {
    id: 4,
    img: require("../../assets/images/social-app/post-4.png"),
  },
  {
    id: 5,
    img: require("../../assets/images/social-app/post-5.png"),
  },
  {
    id: 6,
    img: require("../../assets/images/social-app/post-6.png"),
  },
  {
    id: 7,
    img: require("../../assets/images/social-app/post-7.png"),
  },
  {
    id: 8,
    img: require("../../assets/images/social-app/post-8.png"),
  },
];

export const AboutMeData = [
  {
    id: 1,
    icon: <Briefcase />,
    designation: "UX desginer at Pixelstrap",
    place: "banglore - 2021",
  },
  {
    id: 2,
    icon: <Book />,
    designation: "studied computer science",
    place: "at london univercity - 2022",
  },
  {
    id: 3,
    icon: <Heart />,
    designation: "relationship status",
    place: "single",
  },
  {
    id: 4,
    icon: <MapPin />,
    designation: "lived in london",
    place: "last 5 year",
  },
  {
    id: 5,
    icon: <Droplet />,
    designation: "blood group",
    place: "O+ positive",
  },
];
export const FollowingsData = [
  {
    id: 1,
    img: require("../../assets/images/user/3.png"),
    name: "Sarah Loren",
  },
  {
    id: 2,
    img: require("../../assets/images/user/2.png"),
    name: "Bucky Barnes",
  },
  {
    id: 3,
    img: require("../../assets/images/user/10.jpg"),
    name: "Comeren Diaz",
  },
  {
    id: 4,
    img: require("../../assets/images/user/11.png"),
    name: "Jason Borne",
  },
  {
    id: 5,
    img: require("../../assets/images/user/3.png"),
    name: "Andew Jon",
  },
];
export const FollowersData = [
  {
    id: 1,
    img: require("../../assets/images/user/2.png"),
    name: "Bucky Barnes",
  },
  {
    id: 2,
    img: require("../../assets/images/user/3.png"),
    name: "Sarah Loren",
  },
  {
    id: 3,
    img: require("../../assets/images/user/4.jpg"),
    name: "Jason Borne",
  },
  {
    id: 4,
    img: require("../../assets/images/user/10.jpg"),
    name: "Comeren Diaz",
  },
  {
    id: 5,
    img: require("../../assets/images/user/11.png"),
    name: "Andew Jon",
  },
];

export const TreeViewData = {
  name: "",
  children: [
    {
      name: "root",
      children: [
        {
          name: "Applications",
          children: [{ name: "Ecommerce" }, { name: "Users" }, { name: "Chat" }],
        },
        {
          name: "Components",
          children: [{ name: "UI-Kits" }, { name: "Bonus-UI" }, { name: "Charts" }],
        },
        {
          name: "Miscellaneous",
          children: [{ name: "Gallery" }, { name: "Blog" }, { name: "Editors" }],
        },
      ],
    },
  ],
};
